import React from 'react';

import classNames from 'classnames';
import { Button } from '../../button';
import { numberToBengali } from '../../../utils/convertToBengaliNumber';

const BUTTON_STYLE =
  'pagination-page-btn rounded-circle text-center fw-medium bg-transparent';

const Page = ({ data, activePage, language, onClickPage }) => {
  return data.map((pageNumber: number, i: number) => (
    <Button
      key={i}
      className={classNames(BUTTON_STYLE, {
        'pagination-active': activePage === pageNumber,
      })}
      isPadding={false}
      onClick={() => onClickPage(pageNumber)}
      size="xs"
    >
      {language === 'bn' ? numberToBengali(pageNumber) : pageNumber}
    </Button>
  ));
};

export default Page;
